import { getCurrentAppByHostname } from '../../Helpers';
import { ReportListQuerySortBy } from '../ReportService';
import { ReportListGroupedBy } from '../../Components/ReportList/ReportSortGroupByButton/ReportSortGroupByButtonMenu/ReportSortGroupByButtonMenu';

const MyReportsSearchStorage = `Smartforce.${
  getCurrentAppByHostname() === 'nexus' ? 'Nexus' : 'CitizenContact'
}.MyReportsSearchConfig`;

export interface MyReportsSearchConfigType {
  sortBy: ReportListQuerySortBy;
  groupedBy: ReportListGroupedBy;
  wsId?: string;
}

export const getMyReportsSearchConfig = (
  wsId?: string
): MyReportsSearchConfigType => {
  const storageKey = wsId
    ? `${MyReportsSearchStorage}.WS_ID.${wsId}`
    : MyReportsSearchStorage;
  return localStorage.getItem(storageKey)
    ? JSON.parse(localStorage.getItem(storageKey) as string)
    : {
        sortBy: 'newest',
        groupedBy: 'report'
      };
};

export const setMyReportsSearchConfig = (
  filters: MyReportsSearchConfigType,
  wsId?: string
): void => {
  const storageKey = wsId
    ? `${MyReportsSearchStorage}.WS_ID.${wsId}`
    : MyReportsSearchStorage;
  localStorage.setItem(storageKey, JSON.stringify(filters));
};
